import { useState } from 'react';
import { VerlaufButton, VerlaufKomplett } from './LinienführungAnlegenCss';

var MonitorApi = require('monitor-api');

export default function AuswahlRückrichtungNeueInfrastruktur({ rrCollection, setRrCollection, bhfListe, strInstance, strVerlInstance }) {
    const [filteredRrBhfListe, setfilteredRrBhfListe] = useState([]);
    const [streckenListe, setStreckenListe] = useState({
        suchanfrage: {
            idStartBhf: undefined,
            idEndBhf: undefined
        },
        allStrecken: [],
        showVerlauf: {}
    });

    function handleNeueStreckeChange(e) {
        e.preventDefault();
        setRrCollection({
            ...rrCollection,
            neueStrecke: !rrCollection.neueStrecke,
            rrHalte: {},
            rrVerlauf: [],
            rrStreckenId: undefined,
            mirrored: undefined,
            bisherigeStrNutzen: false,
            rrAnalog: false
        });

        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                idStartBhf: undefined,
                idEndBhf: undefined
            },
            allStrecken: [],
            showVerlauf: {}
        });
    }

    function handleStartBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idStartBhf: e.target.value
            }
        });

        filterBhfListe(e.target.value);
    }

    function filterBhfListe(idStartBhf) {
        strInstance.getPossibleEnds(idStartBhf, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load bhfListe', data);
                setfilteredRrBhfListe(data);
            }
        })
    }


    function handleEndBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idEndBhf: e.target.value
            }
        });
    }

    const loadStrecken = (event) => {
        event.preventDefault();
        var startEnd = new MonitorApi.StreckeVonBis();
        startEnd.id_eins = streckenListe.suchanfrage.idStartBhf;
        startEnd.id_zwei = streckenListe.suchanfrage.idEndBhf;
        strVerlInstance.searchStreckenverlaufStreckenverlaufSuchePatch(startEnd, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load Strecken rr', data);
                handleStreckenLoad(data);
            }
        })
    }
    function handleStreckenLoad(data) {
        let verlaufShow = {};
        data.forEach(str => verlaufShow[str.id_strecke] = false);
        setStreckenListe({
            ...streckenListe,
            allStrecken: data,
            showVerlauf: verlaufShow
        });
    }

    function handleVerlaufShow(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            showVerlauf: {
                ...streckenListe.showVerlauf,
                [e.target.value]: !streckenListe.showVerlauf[e.target.value]
            }
        });
    }

    function updateRadios(e) {
        console.log("radio: ", e.target.value);

        let specificStrecke = streckenListe.allStrecken.filter(str => str.id_strecke === parseInt(e.target.value))[0].strecke;
        specificStrecke.forEach(str => str.verlauf = true);
        let halte = {};
        specificStrecke.forEach(station => halte[station.pos] = true)
        setRrCollection({
            ...rrCollection,
            rrVerlauf: specificStrecke,
            rrHalte: halte,
            rrStreckenId: parseInt(e.target.value),
            mirrored: streckenListe.allStrecken
                .filter(str => str.id_strecke === parseInt(e.target.value))[0]
                .mirrored
        });
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    const updateVerlauf = (e) => {
        e.preventDefault();
        handleVerlaufChange(e.target.id);
    }

    function handleVerlaufChange(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        let currentState = completeStation.verlauf;
        completeStation.verlauf = !currentState;
        if (!currentState) {
            // nur wenn verlauf auf ja, dann halt auch
            handleHalteChange(bhfPos, true);
        }
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    function updateHalte(e) {
        handleHalteChange(e.target.value, e.target.checked);
    }

    function handleHalteChange(bhfPos, newState) {
        let currentHalte = rrCollection.rrHalte;
        currentHalte[bhfPos] = newState;
        if (!newState) {
            // wenn auf nein, dann auch verlauf nein
            setVerlaufFalse(bhfPos);
        }
        setRrCollection({
            ...rrCollection,
            rrHalte: currentHalte
        });
    }


    function setVerlaufFalse(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        completeStation.verlauf = false;
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    return (
        <div>
            <button className="ausklappsie" onClick={(e) => handleNeueStreckeChange(e)}>
                <label>
                    {rrCollection.neueStrecke ? <span>&#8722; </span> : <span>&#43; </span>}
                    neue Strecke hinzufügen:
                </label>
            </button>
            {rrCollection.neueStrecke && <section className="ausklappsie-klappe">
                <h5>Strecke auswählen:</h5>
                <label>Start-Bahnhof:</label>
                <select onChange={(event) => handleStartBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {bhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>

                <label>End-Bahnhof:</label>
                <select onChange={(event) => handleEndBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {filteredRrBhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>
                {<button disabled={!streckenListe.suchanfrage.idStartBhf || !streckenListe.suchanfrage.idEndBhf}
                    onClick={e => loadStrecken(e)}>Strecken suchen</button>}
                <p>{JSON.stringify(streckenListe)}</p>
                <div>
                    {streckenListe.allStrecken.map(strecke =>
                        <fieldset key={strecke.id_strecke}>
                            <label>
                                <input type="radio" value={strecke.id_strecke} name="strecke"
                                    onChange={event => updateRadios(event)} />
                                Anzahl Bahnhöfe: {strecke.strecke.length}
                            </label>
                            {rrCollection.rrStreckenId !== strecke.id_strecke && <>
                                <br></br>
                                <button style={{ margin: "1em 2em" }} value={strecke.id_strecke}
                                    onClick={(e) => handleVerlaufShow(e)}>
                                    {streckenListe.showVerlauf[strecke.id_strecke] ? <span>&#8722; </span> : <span>&#43; </span>}
                                    vollständiger Verlauf</button>
                            </>}
                            {streckenListe.showVerlauf[strecke.id_strecke] &&
                                orderingVerlauf(strecke.strecke, strecke.mirrored).map(bhf => <label key={bhf.pos}>-{bhf.pos}: {bhf.bhf}-</label>)}
                            {rrCollection.rrStreckenId === strecke.id_strecke &&
                                <VerlaufKomplett>
                                    <thead>
                                        <tr>
                                            <th>in Verlaufsbeschreibung</th>
                                            <th>Halt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderingVerlauf(strecke.strecke, strecke.mirrored).map(bhf =>
                                            <tr key={bhf.pos}>
                                                <td><VerlaufButton id={bhf.pos} value={bhf.pos} onClick={(e) => updateVerlauf(e)}
                                                    className={rrCollection.rrVerlauf.filter(station => station.pos === bhf.pos)[0].verlauf ? "active" : "inactive"}>
                                                    <span id={bhf.pos}>{bhf.pos}: </span>{bhf.bhf}</VerlaufButton>
                                                </td>
                                                <td><input type="checkbox" value={bhf.pos} onChange={(e) => updateHalte(e)}
                                                    // disabled={!rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhf.pos))[0].verlauf}
                                                    checked={rrCollection.rrHalte[bhf.pos]} />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </VerlaufKomplett>
                            }
                        </fieldset>)
                    }
                </div>
            </section>}
        </div >
    )
}
